var Type = /* @__PURE__ */ ((Type2) => {
  Type2[Type2["SHARE_TYPE_USER"] = 0] = "SHARE_TYPE_USER";
  Type2[Type2["SHARE_TYPE_GROUP"] = 1] = "SHARE_TYPE_GROUP";
  Type2[Type2["SHARE_TYPE_LINK"] = 3] = "SHARE_TYPE_LINK";
  Type2[Type2["SHARE_TYPE_EMAIL"] = 4] = "SHARE_TYPE_EMAIL";
  Type2[Type2["SHARE_TYPE_REMOTE"] = 6] = "SHARE_TYPE_REMOTE";
  Type2[Type2["SHARE_TYPE_CIRCLE"] = 7] = "SHARE_TYPE_CIRCLE";
  Type2[Type2["SHARE_TYPE_GUEST"] = 8] = "SHARE_TYPE_GUEST";
  Type2[Type2["SHARE_TYPE_REMOTE_GROUP"] = 9] = "SHARE_TYPE_REMOTE_GROUP";
  Type2[Type2["SHARE_TYPE_ROOM"] = 10] = "SHARE_TYPE_ROOM";
  Type2[Type2["SHARE_TYPE_DECK"] = 12] = "SHARE_TYPE_DECK";
  Type2[Type2["SHARE_TYPE_FEDERATED_GROUP"] = 14] = "SHARE_TYPE_FEDERATED_GROUP";
  return Type2;
})(Type || {});
var ShareType = /* @__PURE__ */ ((ShareType2) => {
  ShareType2[ShareType2["User"] = 0] = "User";
  ShareType2[ShareType2["Grup"] = 1] = "Grup";
  ShareType2[ShareType2["Link"] = 3] = "Link";
  ShareType2[ShareType2["Email"] = 4] = "Email";
  ShareType2[ShareType2["Remote"] = 6] = "Remote";
  ShareType2[ShareType2["Team"] = 7] = "Team";
  ShareType2[ShareType2["Guest"] = 8] = "Guest";
  ShareType2[ShareType2["RemoteGroup"] = 9] = "RemoteGroup";
  ShareType2[ShareType2["Room"] = 10] = "Room";
  ShareType2[ShareType2["Deck"] = 12] = "Deck";
  ShareType2[ShareType2["FederatedGroup"] = 14] = "FederatedGroup";
  return ShareType2;
})(ShareType || {});
export {
  ShareType,
  Type
};
